module.exports = __webpack_public_path__ + "static/media/icon-pill-paddle-tennis.e4bb2e20.svg";